import { DiscountTargetType } from "@/lib/gql/__generated__/graphql";

import type { FormOptionType } from "@/components/ui/form/_types/type";

export const StaticTargetTypeOptions = [
	{
		id: DiscountTargetType.PerGroup,
		label: "団体様",
		value: DiscountTargetType.PerGroup,
	},
	{
		id: DiscountTargetType.PerPerson,
		label: "お一人様",
		value: DiscountTargetType.PerPerson,
	},
	{
		id: DiscountTargetType.PerRoom,
		label: "一部屋",
		value: DiscountTargetType.PerRoom,
	},
] satisfies Array<FormOptionType>;
